import BootstrapTable, { BootstrapTableProps } from 'react-bootstrap-table-next';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { setCurrentPage, setTablePageSize } from '../../redux/actions';
import { ReactNode } from 'react';
import ShowMoreText from 'react-show-more-text';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { fetchPodcasts, deletePodcast } from '../../utils/api';
import { Link } from 'react-router-dom';
import CustomSearch from '../ui/CustomSearch/CustomSearch';
import { UserInfoType, GroupType } from '../../types/AppTypes';
import { RootState } from '../../redux/store';
import { useSelector } from 'react-redux';

const { SearchBar } = Search;

type Props = {
  users: GroupType[];
};

const Table = ({ users }: Props): JSX.Element => {

  const userInfo = useSelector((state: RootState) => state.userInfo.userInfo) as UserInfoType;

  const permissions = userInfo?.permissions;

  const columns = [
    {
      dataField: 'username',
      text: 'Username',
      headerAlign: 'center',
      align: 'center',
      sort: true,
    },
    {
      dataField: 'groups',
      text: 'Groups',
      headerAlign: 'center',
      align: 'center',
      formatter: (_cell: any, row: any) => (
        <div>
          {JSON.stringify(_cell)}
        </div>
      ),
    },
    /*{
      dataField: 'delete',
      hidden: permissions?.includes('podcasts.delete') || userInfo?.isAdmin? false : true,
      text: '',
      isDummyField: true,
      csvExport: false,
      formatter: (_cell: any, row: any) => (
        <div
          style={{ cursor: 'pointer', color: 'red' }}
          onClick={() => {
            if (window.confirm('Delete a job?')) {
              deletePodcast(row.id).then((res) => {
                fetchPodcasts(dispatch);
              });
            }
          }}
        >
          Delete
        </div>
      ),
      headerAlign: 'center',
      align: 'center',
      headerStyle: (colum, colIndex) => {
        return { width: '100px', textAlign: 'center' };
      },
    },*/
    {
      dataField: 'edit',
      hidden: permissions?.includes('users.edit') || userInfo?.isAdmin? false : true,
      text: '',
      isDummyField: true,
      csvExport: false,
      formatter: (_cell: any, row: any) =>
          <Link to={`/user/${row.username}`}>Edit</Link>,
      headerAlign: 'center',
      align: 'center',
      headerStyle: (colum, colIndex) => {
        return { width: '100px', textAlign: 'center' };
      }
    },
  ];
  const data = users && users.length ? users : [];
  const dispatch = useAppDispatch();
  const tablePageSize = useAppSelector((state) => state.groups.tablePageSize);
  const currentPage = useAppSelector((state) => state.groups.currentPage);
  const searchQuery =
    localStorage.getItem('users_search_input') !== null && localStorage.getItem('users_search_input') !== ''
      ? localStorage.getItem('users_search_input')
      : '';
  const pagination = paginationFactory({
    sizePerPage: parseInt(localStorage.getItem('users-table-size') || '', 10) || tablePageSize,
    page: currentPage,
    onPageChange: (page) => {
      dispatch(setCurrentPage(page));
    },
    onSizePerPageChange: (sizePage) => {
      sizePerPageUsersChange(sizePage);
      dispatch(setTablePageSize(sizePage));
    },
  });

  const sizePerPageUsersChange = (sizePerPage: number) => {
    localStorage.setItem('users-table-size', sizePerPage.toString());
  };

  return (
    <div style={{ marginBottom: '15px' }}>
      <ToolkitProvider
        keyField="id"
        data={data}
        columns={columns}
        striped
        hover
        condensed
        //sort={{ dataField: 'created', order: 'desc' }}
        search={{ defaultSearch: '' }}
      >
        {(props: {
          searchProps: {
            searchText: string | number;
            onSearch: (searchText: string | number) => void;
            onClear: () => void;
          };
          baseProps: JSX.IntrinsicAttributes &
            JSX.IntrinsicClassAttributes<BootstrapTable<any, number>> &
            Readonly<BootstrapTableProps<any, number>> &
            Readonly<{ children?: ReactNode }>;
        }) => (
          <div>
            <CustomSearch {...props.searchProps} defaultValue={searchQuery} localStorageItemName="users_search_input" />
            <hr />
            <BootstrapTable {...props.baseProps} pagination={pagination} rowStyle={{ wordBreak: 'break-word' }} />
          </div>
        )}
      </ToolkitProvider>
    </div>
  );
};

export default Table;
